package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.alt
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val avatar = Bem("admin-avatar")

/**
 * A person's photo, or their [initials] without one; [large] in detail panels. Decorative, as the name stands next to
 * it, unless [alt] describes it.
 */
@Composable
fun AdminAvatar(initials: String, imageUrl: String?, large: Boolean = false, alt: String = "") {
    val classes = listOfNotNull(avatar.block, avatar.modifier("large").takeIf { large }).toTypedArray()
    if (imageUrl != null) {
        Img(imageUrl, attrs = {
            classes(*classes)
            alt(alt)
            attr("loading", "lazy")
        })
    } else {
        Span({
            classes(*classes)
            attr("aria-hidden", "true")
        }) { Text(initials) }
    }
}
